import { render, staticRenderFns } from "./upstreamHedgingDetail.vue?vue&type=template&id=4141d7e2&scoped=true"
import script from "./upstreamHedgingDetail.vue?vue&type=script&lang=js"
export * from "./upstreamHedgingDetail.vue?vue&type=script&lang=js"
import style0 from "./upstreamHedgingDetail.vue?vue&type=style&index=0&id=4141d7e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141d7e2",
  null
  
)

export default component.exports